export default "__VITE_PUBLIC_ASSET__b244d009__"